<template>
  <div class="main-box">
    <p class="title-crumb" @click="go()" style="cursor: pointer;">
      <i class="el-icon-back"></i>
      <el-breadcrumb separator-class="el-icon-arrow-right color3">
        <el-breadcrumb-item>预警统计</el-breadcrumb-item>
      </el-breadcrumb>
    </p>
    <div class="box-content">
      <div class="head">
        <el-date-picker
          v-model="time"
          value-format="yyyy-MM"
          type="month"
          @change="doFilter"
          placeholder="选择日期"
        >
        </el-date-picker>
        <div></div>
        <div>设备号{{ deviceId }}</div>
      </div>
      <div class="content1">
        <el-table :data="tableData" height="100%" border style="width: 100%;">
          <template slot="empty">
              <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号" width="80">
              <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
              </template>
          </el-table-column>
          <el-table-column label="预警内容">
              <template slot-scope="scope">
              <a>{{ scope.row.name}}</a>
              </template>
          </el-table-column>
          <el-table-column label="高度">
              <template slot-scope="scope">
                <span v-if="scope.row.heightStatus=='正常'" style="color:#67C23A;">{{ scope.row.height}} m</span>
                <span v-else style="color:#F56C6C;">{{ scope.row.height}} m</span>
              </template>
          </el-table-column>
          <el-table-column label="速度">
              <template slot-scope="scope">
                <span v-if="scope.row.speedStatus=='正常'" style="color:#67C23A;">{{ scope.row.speed}} m/s</span>
                <span v-else style="color:#F56C6C;">{{ scope.row.speed}} m/s</span>
              </template>
          </el-table-column>
          <el-table-column label="倾角">
              <template slot-scope="scope">
                <span v-if="scope.row.tiltStatus=='正常'" style="color:#67C23A;">{{ scope.row.tilt}} °</span>
                <span v-else style="color:#F56C6C;">{{ scope.row.tilt}} °</span>
              </template>
          </el-table-column>
          <el-table-column label="重量">
              <template slot-scope="scope">
                <span v-if="scope.row.weightStatus=='正常'" style="color:#67C23A;">{{ scope.row.weight}} T</span>
                <span v-else style="color:#F56C6C;">{{ scope.row.weight}} T</span>
              </template>
          </el-table-column>
          <el-table-column label="时间">
              <template slot-scope="scope">
                <span>{{ scope.row.createDate }}</span>
              </template>
          </el-table-column>
        </el-table>
        <!-- <div style="width: 10%; height: 100%">
          <ul class="ulhead">
            <li  class="listy" v-for="(item, index) in listTh" :key="index" >{{ item }}</li>
          </ul>
        </div>
        <div style="width: 90%; height: 100%">
          <ul class="ulhead ulhead2">
            <li class="listy colorBg"  style="width: 100%;display: flex;justify-content: space-around;" >             
             <span  v-for="(item, index) in frontList" :key="index" :class="{ color: item != '--' }">{{item}}</span>
            </li>
            <li class="listy colorBg"  style="width: 100%;display: flex;justify-content: space-around;">
             <span  v-for="(item, index) in behindList" :key="index" :class="{ color: item != '--' }">{{item}}</span>
            </li>
            <li class="listy colorBg"  style="width: 100%;display: flex;justify-content: space-around;">
             <span  v-for="(item, index) in tiltList" :key="index" :class="{ color: item != '--' }">{{item}}</span>
            </li>
            <li class="listy colorBg"  style="width: 100%;display: flex;justify-content: space-around;">
             <span  v-for="(item, index) in weightList" :key="index" :class="{ color: item != '--' }">{{item}}</span>
            </li>
            <li class="listy "  style="width: 100%;display: flex;justify-content: space-around;">
             <span  v-for="(item, index) in createDateList" :key="index" >{{item}}</span>
            </li>

          </ul>
        </div>
        <span style="height: 30px;position: absolute;  bottom: 0;right: 20px;">单位(小时)</span> -->
        <!-- 表单列表 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
  data() {
    return {
      deviceId: '',
      groupId: '',
      time:util.myTime.getCurMonth(),
      // time: '2020-11-09',
      // listTh: [
      //   '高度预警',
      //   '速度预警',
      //   '姿态状态预警',
      //   '重量状态预警',
      //   '',
      // ],
      tableData: [],
      // frontList:[],
      // behindList:[],
      // tiltList:[],
      // weightList:[],
      // lijupercentList:[],
      // createDateList:[],
      // pengzhuangList:[],
      // windspeedList:[],
      dataText:'数据加载中...',
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.deviceId = this.$route.params.id
    this.getData()
  },
  methods: {
    doFilter(){
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage() {
      this.getData()
    },
    //获取列表
    getData(){
      var that = this
      myHttp.moreWarnInformation({
        projectId:this.groupId,
        deviceId:this.deviceId,
        months:this.time,
        pageNum:this.currentPage,
        pageSize:this.pageSize
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.moreWarnList.list||[]
          for(var i=0;i<list.length;i++){
            list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            list[i].name = ''
            if(list[i].heightStatus&&list[i].heightStatus!='正常'){
              list[i].name += list[i].name==''?list[i].heightStatus:','+list[i].heightStatus
            }
            if(list[i].speedStatus&&list[i].speedStatus!='正常'){
              list[i].name += list[i].name==''?list[i].speedStatus:','+list[i].speedStatus
            }
            if(list[i].tiltStatus && list[i].tiltStatus!='正常'){
              list[i].name += list[i].name==''?list[i].tiltStatus:','+list[i].tiltStatus
            }
            if(list[i].weightStatus && list[i].weightStatus!='正常'){
              list[i].name += list[i].name==''?list[i].weightStatus:','+list[i].weightStatus
            }
          }
          that.tableData = list
          that.totalItems = resp.data.data.moreWarnList.total||0
          if(list.length==0){
            that.dataText = '暂无数据'
          }
        }else{
          that.dataText = '暂无数据'
        }
      },function(){that.dataText = '暂无数据'})
    },
    //
    // getData() {
    //   var that = this
    //   myHttp.elevatorLogTimeQuantum({
    //       deviceId: this.deviceId,
    //       projectId: this.groupId,
    //       createDate:this.time
    //   }).then(function(resp){
    //     if(resp.data.code=='200'){
    //       var data = resp.data.data
    //       var createDateList = ['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00']
    //       var frontList = []
    //       var behindList=[]
    //       var tiltList =[]
    //       var weightList = []
    //       for(var i=0;i<createDateList.length;i++){
    //         //高度
    //         frontList.push('--')
    //         var list1 = data.heightWarnTimeQuantum||[]
    //         for(var j=0;j<list1.length;j++){
    //           var it = createDateList[i].split(':')[0]
    //           var ft = list1[j].timeQuantum.split(' ')[1].split(':')[0]
    //           if(it == ft){
    //             frontList[i] = list1[j].warnTimes
    //           }
    //         }
    //         //速度
    //         behindList.push('--')
    //         var list2 = data.speedWarnTimeQuantum||[]
    //         for(var j=0;j<list2.length;j++){
    //           var it = createDateList[i].split(':')[0]
    //           var ft = list2[j].timeQuantum.split(' ')[1].split(':')[0]
    //           if(it == ft){
    //             behindList[i] = list2[j].warnTimes
    //           }
    //         }
    //         //姿态
    //         tiltList.push('--')
    //         var list3 = data.tiltWarnTimeQuantum||[]
    //         for(var j=0;j<list3.length;j++){
    //           var it = createDateList[i].split(':')[0]
    //           var ft = list3[j].timeQuantum.split(' ')[1].split(':')[0]
    //           if(it == ft){
    //             tiltList[i] = list3[j].warnTimes
    //           }
    //         }
    //         //重量
    //         weightList.push('--')
    //         var list4 = data.weightWarnTimeQuantum||[]
    //         for(var j=0;j<list4.length;j++){
    //           var it = createDateList[i].split(':')[0]
    //           var ft = list4[j].timeQuantum.split(' ')[1].split(':')[0]
    //           if(it == ft){
    //             weightList[i] = list4[j].warnTimes
    //           }
    //         }
    //       }
    //       that.frontList = frontList
    //       that.behindList = behindList
    //       that.tiltList = tiltList
    //       that.weightList = weightList
    //       that.createDateList = createDateList
    //     }
    //   })
    //},
    isData(arr){
      for(var i = 0;i<arr.length;i++){
         arr[i]=arr[i]>0?arr[i]:'--'
      }
      return arr
    },
    go() {
      this.$router.go(-1)
    },
  },
}
</script>
<style scoped>
.main-box {
  width: 100%;
  height: 100%;
  position: relative;
  padding:0 1vh;
}
.box-content {
  width: 100%;
  height: calc(100% - 5vh);
  background: #fff;
}
.head {
  display: flex;
  height: 6vh;
  padding: 1vh;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #409EFF;
}
.content1 {
  /* display: flex; */
  height: calc(100% - 12vh);
}
.ulhead {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.ulhead2 {
  display: flex;
}
.listy{
 height: 40px;
 padding: 1vh;

}
.colorBg{
 background: #f4f7fc;
}
.color{
 color: #f00;
}
</style>